<template>
  <div class="w-full h-full">
    <div class="w-full h-full flex relative">
      <div class="w-full flex-1 flex flex-col relative h-full">
        <div class="w-full space-y-4 py-1">
          <div class="w-full py-3 md:flex space-y-3 md:space-y-0 justify-between px-3 items-center">
            <div>
              <p class="text-3xl">{{ $t('voscommandes') }}</p>
            </div>
            <form @submit.prevent="search" class="md:w-[40%] w-full h-10 bg-red-500 relative rounded-full overflow-hidden ">
              <button :disabled="disable ? true:false" type="submit" class="bg-[#FF9900] w-[20%] h-full absolute right-0 flex items-center">
                <img class="w-3 h-3 mx-auto" src="/icons/search.png" alt="" srcset="">
              </button>
              <input @click="goPageSearch" v-model="matriculeSearch" @keyup="searchRefresh" type="text" required id="input-group-1" class=" bg-gray-100 border border-white w-[80%] h-full rounded-l-full  text-sm  focus:ring-[#FF9900] focus:border-[#FF9900] block  p-2  placeholder-gray-400 focus:outline-none" :placeholder="$t('recherchezmatricule')" :disabled="disable ? true:false"/> 
            </form>
          </div>
          <div class="w-full nav-commande  space-x-2 px-1 flex flex-row scrollbar-hide overflow-x-auto">
            <router-link to="/mes-commandes" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('tout') }}</p>
            </router-link> 
            <router-link to="/recus-en-cours-livraison" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusencourlivraison') }}</p>
            </router-link>
            <router-link to="/recus-en-cours-recuperation" class=" flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusencourrecuperation') }}</p>
            </router-link>
            <router-link to="/recus-valides" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusvalides') }}</p>
            </router-link>
            <router-link to="/recus-annules" class="flex-shrink-0 h-full px-2 flex items-center text-gray-400">
              <p class="mx-auto">{{ $t('recusannules') }}</p>
            </router-link>
          </div>
        </div>
        <div class="h-full w-full flex flex-col">
          <router-view name="seven"></router-view>
          <div class="w-[98%]">
            <p class="font-baskerville font-semibold text-sm">{{ $t('encourlivraison') }}(s): {{ nbrEnCourLivraison }} &nbsp; {{ $t('encourrecuperation') }}(s): {{ nbrEnCourRecuperation }} &nbsp; {{ $t('valide') }}(s): {{ nbrValide }} &nbsp; {{ $t('annule') }}(s): {{ nbrAnnule }}</p>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      nbrEnCourLivraison:0,
      nbrEnCourRecuperation:0,
      nbrValide:0,
      nbrAnnule:0,
      matriculeSearch:'',
      disable:''
    }
  },
  watch: {
      requestNbrEnCourLivraisonCommande: {
        handler(newValue) {
          this.nbrEnCourLivraison = newValue
        },
        deep: true
      },
      requestNbrEnCourRecuperationCommande: {
        handler(newValue) {
          this.nbrEnCourRecuperation = newValue
        },
        deep: true
      },
      requestNbrValideCommande: {
        handler(newValue) {
          this.nbrValide = newValue
        },
        deep: true
      },
      requestNbrAnnuleCommande: {
        handler(newValue) {
          this.nbrAnnule = newValue
        },
        deep: true
      },
    },
  beforeRouteLeave() {
    window.emitter.off("disableInputSearchCommande")
  },
  created(){
    window.emitter.on("disableInputSearchCommande", (value) => {
      this.disable = value
    })
  },
  mounted(){
    if(this.$store.state.factures.length > 0 || this.$store.state.factureValide.length > 0 || this.$store.state.facturesEnCoursLivraison.length > 0){
      this.nbrEnCourLivraison = this.$store.state.nbrEnCourLivraisonCommande
      this.nbrEnCourRecuperation = this.$store.state.nbrEnCourRecuperationCommande
      this.nbrValide = this.$store.state.nbrValideCommande
      this.nbrAnnule = this.$store.state.nbrAnnuleCommande
    }else{
      this.axios.get(this.requestHttp + 'stat-commande',{
          headers: {
              'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
          },
      }).then(({ data }) => {
          this.$store.state.nbrEnCourLivraisonCommande = data[0]
          this.$store.state.nbrEnCourRecuperationCommande = data[1]
          this.$store.state.nbrValideCommande = data[2]
          this.$store.state.nbrAnnuleCommande = data[3]
      })
      .catch((error) => {
          console.log(error)
      });
    }
  },
  methods:{
    goPageSearch(){
      this.$router.push('/mes-commandes');
    },
    searchRefresh(){
      if(this.matriculeSearch.length == 0){
        window.emitter.emit("searchCommande", this.matriculeSearch)
      }
    },
    search(){
      if(this.matriculeSearch.length > 0){
        window.emitter.emit("searchCommande", this.matriculeSearch)
      }
    },
  },
  computed:{
    requestToutMesArticles(){
      return this.$store.state.toutMesArticles
    },
    requestAccueil(){
      return this.$store.state.dataAccueil
    },
    requestHttp(){
      return this.$store.state.api
    },
    requestNbrEnCourLivraisonCommande(){
      return this.$store.state.nbrEnCourLivraisonCommande
    },
    requestNbrEnCourRecuperationCommande(){
      return this.$store.state.nbrEnCourRecuperationCommande
    },
    requestNbrValideCommande(){
      return this.$store.state.nbrValideCommande
    },
    requestNbrAnnuleCommande(){
      return this.$store.state.nbrAnnuleCommande
    },
  }
}
</script>

<style>
  .nav-commande .router-link-exact-active {
    border-color: #FF9900;
    border-bottom-width: 4px;
    color: black;
  }
</style>